<template>
  <BaseStatusBar
    :show_switcher="shouldShowSwitcher"
    :current_tab="current_tab"
    :icon="currentIcon"
    @switchTab="onSwitchTab"
  >
    <template v-slot:first_tab v-if="order.status == 'waiting'">
      <h3 class="waiting-time">{{ formatDuration(accept_minutes) }}</h3>
      <p>{{ $t("inside_status_bar.accept_desc") }}</p>
    </template>
    <template v-slot:first_tab v-else-if="order.status == 'serving' && !order.served_at">
      <h3 class="serve-time">{{ formatDuration(serve_minutes) }}</h3>
      <p>{{ order.waiting_time ? $t('inside_status_bar.serve_desc') : $t('inside_status_bar.serving') }}</p>
    </template>
    <template v-slot:first_tab v-else-if="order.status == 'serving' && order.served_at">
      <h3>{{ $t("inside_status_bar.served") }}</h3>
    </template>
    <template v-slot:first_tab v-else-if="order.status == 'editing'">
      <h3 class="editing-title">{{ $t("inside_status_bar.editing") }}</h3>
    </template>
    <template v-slot:first_tab v-else-if="splitting">
      <h3 class="splitting-title">{{ $t("inside_status_bar.splitting") }}</h3>
    </template>
    <template v-slot:first_tab v-else-if="order.status == 'paying'">
      <h3 class="status-unpaid">{{ $t("preorder_status_bar.unpaid") }}</h3>
      <p>{{ $t("preorder_status_bar.pay_status") }}</p>
    </template>
    <template v-slot:first_tab v-else-if="isOrderPaid">
      <h3 class="status-paid">{{ $t("preorder_status_bar.paid") }}</h3>
      <p>{{ $t("preorder_status_bar.pay_status") }}</p>
    </template>
    <template v-slot:second_tab v-if="isOrderPaid">
      <h3 class="status-paid">{{ $t("preorder_status_bar.paid") }}</h3>
      <p>{{ $t("preorder_status_bar.pay_status") }}</p>
    </template>
    <template v-slot:second_tab v-else>
      <h3 class="status-unpaid">{{ $t("preorder_status_bar.unpaid") }}</h3>
      <p>{{ $t("preorder_status_bar.pay_status") }}</p>
    </template>
  </BaseStatusBar>
</template>

<script>
import BaseStatusBar from "@/components/statusbar/BaseStatusBar.vue";

import moment from "moment";

export default {
  props: {
    order: Object,
    splitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current_tab: 0,

      accept_minutes: 0,
      serve_minutes: 0,
    };
  },
  watch: {
    "order.status"() {
      this.checkTimers();
    },
  },
  methods: {
    onSwitchTab() {
      if (!this.shouldShowSwitcher) return;

      if (this.current_tab == 0) {
        this.current_tab = 1;
      } else {
        this.current_tab = 0;
      }
    },
    tickAcceptTimer() {
      if (this.order.status != "waiting") return;

      this.accept_minutes = moment().diff(moment(this.order.date), "minutes");

      setTimeout(this.tickAcceptTimer, 30 * 1000);
    },
    tickServeTimer() {
      if (this.order.waiting_time) {
        this.serve_minutes = moment(this.order.processed_at)
          .add(this.order.waiting_time, "minutes")
          .diff(moment(), "minutes");
      } else {
        const then = moment(this.order.processed_at);

        this.serve_minutes = moment().diff(then, "minutes");
      }

      setTimeout(this.tickServeTimer, 30 * 1000);
    },
    checkTimers() {
      this.tickAcceptTimer();
      this.tickServeTimer();
    },
    formatDuration(mins) {
      if (mins == 0) {
        return `0 ${this.$t('waiting.time')}`;
      }

      let hours = Math.floor(mins / 60);
      let remainder = mins % 60;

      let result = '';

      if (hours > 0) {
        result += `${hours} ${this.$t('waiting.hours')} `;
      }

      if (remainder > 0) {
        result += `${remainder} ${this.$t('waiting.time')}`;
      }

      return result;
    }
  },
  mounted() {
    this.checkTimers();
  },
  computed: {
    shouldShowSwitcher() {
      return this.order.status == "serving";
    },
    currentIcon() {
      if (
        this.current_tab == 0 &&
        (this.splitting || this.order.status == "editing")
      ) {
        return "/icons/pencil-yellow.svg";
      }

      if (
        this.current_tab == 1 ||
        this.order.status == "paying" ||
        this.isOrderPaid
      ) {
        return this.isOrderPaid
          ? "/icons/status-payment-green.svg"
          : "/icons/status-payment-red.svg";
      }

      if (this.order.status == "waiting") {
        return "/icons/status-timer-yellow.svg";
      }

      if (this.order.status == "serving") {
        return "/icons/status-timer-blue.svg";
      }
    },
    isOrderPaid() {
      return this.order.status == "executed";
    },
  },
  components: {
    BaseStatusBar,
  },
};
</script>

<style scoped>
.status-paid {
  color: #129b81 !important;
}

.status-unpaid {
  color: #e2223b !important;
}

.waiting-time {
  color: #ffd2a8 !important;
}

.serve-time {
  color: #aeccc6 !important;
}

h3.editing-title {
  color: #ffd2a8;
}

@media (min-width: 768px) {
  h3.waiting-time {
    font-size: 1.597vw;
    line-height: 1.806vw;
  }
  p.pay-status {
    font-size: 0.903vw;
    line-height: 1.042vw;
  }
  h3.serve-time {
    font-size: 1.597vw;
    line-height: 1.806vw;
  }
  h3.status-unpaid {
    font-size: 1.597vw;
    line-height: 1.806vw;
  }
}
</style>
